import { storage } from "@/lib/appwrite";
import { ID } from "appwrite";

const bucketId = import.meta.env.VITE_BLOCKCHAIN_ANEXOS_SERVICE_REPORT_BUCKET_ID!;

export async function uploadReportFile(file: File): Promise<string> {
    const result = await storage.createFile(bucketId, ID.unique(), file);
    return result.$id;
}

export function getReportFilePreviewUrl(fileId: string): string {
    return storage.getFileView(bucketId, fileId).toString();
}

export async function getReportFileName(fileId: string): Promise<string> {
    const file = await storage.getFile(bucketId, fileId)
    return file.name
}